/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import BaseComponent from './BaseCom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from "@fullcalendar/timegrid";
import Auth from '../shared/Auth';
import Globals from '../shared/Globals';
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { Link } from 'react-router-dom';
import { qreq } from '../shared/qrequest';
import './Calendar.css';
import Icon from './Icon';
import AppFloatingActions from './AppFloatingActions';
import L from './Lang';
import interactionPlugin from '@fullcalendar/interaction';
import { Modal } from 'react-bootstrap';

class Calendar extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            list: [],
            initialDate: null,
            cityList: [],
            distanceList: [
                { id: 10, name: '10 miles' },
                { id: 25, name: '25 miles' },
                { id: 50, name: '50 miles' },
                { id: 100, name: '100 miles' },
                { id: 200, name: '200 miles' },
                { id: 500, name: '500 miles' }
            ],
            filter: {},
            localFilter: {},
            initialView: null,
            calendarHeight: 'auto'
        };
        this.load = this.load.bind(this);
        this.loadDate = this.loadDate.bind(this);
        this.renderEventContent = this.renderEventContent.bind(this);
        this.onDatesSet = this.onDatesSet.bind(this);
        this.eventClick = this.eventClick.bind(this);
        this.resize = this.resize.bind(this);
        this.isFilter = this.isFilter.bind(this);
        this.search = this.search.bind(this);
        this.loadLegend = this.loadLegend.bind(this);
    }

    componentDidMount() {
        this.loadDate();

        qreq.get('/api/visit/calendar/view', j => {
            if (j.item)
                this.setState({ initialView: j.item });
            else
                this.setState({ initialView: 'dayGridMonth' });
        }, () => {
            this.setState({ initialView: 'dayGridMonth' });
        });
        document.addEventListener('resize', this.resize);
        this.resize();
    }

    componentWillUnmount() {
        document.removeEventListener('resize', this.resize);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
            this.setState({ user: this.props.user });
    }

    resize() {
        if (this.isMobile())
            this.setState({ calendarHeight: window.innerHeight - 250 });
    }

    isFilter() {
        return this.state.showFilter || this.state.filter.city || this.state.filter.distance;
    }

    incMonth(dt) {
        try {
            var m = Number(dt.getUTCMonth());
            var y = Number(dt.getUTCFullYear());
            if (m >= 11) {
                dt.setUTCMonth(0);
                dt.setUTCFullYear(y + 1);
            }
            else
                dt.setMonth(m + 1);
        }
        catch (ex) {
            console.log('incMonth exception: ' + ex);
        }
    }

    loadDate() {
        qreq.get('/api/visit/calendar?dt=' + Globals.toISODateString(new Date()), j => {
            if (j.item) {
                var t = Date.parse(j.item);
                var dt = new Date(t);
                var edt = new Date(t);
                this.incMonth(edt);
                var now = new Date();
                if (now > dt && now < edt)
                    this.setState({ initialDate: new Date() });
                else
                    this.setState({ initialDate: new Date(Date.parse(Globals.toISOLocalDateString(dt))) });
            }
            else
                this.setState({ initialDate: new Date() });
        });
    }

    loadLegend(visits) {
        qreq.get('/api/user/list?roleName=medical&showDisabled=false', j => {
            if (j.list) {
                var list = [];
                j.list.forEach(i => {
                    var find = visits.find(a => a.assignedToUserID === i.id);
                    if (find)
                        list.push(i);
                });
                this.setState({ users: list });
            }
        });
    }

    load(startDate, endDate) {
        if (!startDate)
            startDate = new Date();
        if (!endDate) {
            endDate = new Date(startDate);
            var m = Number(endDate.getUTCMonth());
            var y = Number(endDate.getUTCFullYear());
            if (m >= 11)
                endDate.setUTCMonth(0).setUTCFullYear(y + 1);
            else
                endDate.setMonth(m + 1);
        }

        /*
        var now = new Date();
        if(now > startDate && now < endDate)
            this.setState({ initialDate: new Date() });
        */

        qreq.post('/api/visit/list', { startDate: Globals.toISODateString(startDate), endDate: Globals.toISODateString(endDate) }, j => {
            if (j.list) {
                Globals.processResultObject(j);
                var cityList = []
                j.list.forEach(i => {

                    i.title = i.customerName;

                    i.start = new Date(Date.parse(i.plan_date));
                    i.start.setUTCHours(i.start.getUTCHours() + 8);
                    i.end = new Date(Date.parse(i.plan_date));
                    i.end.setUTCHours(i.end.getUTCHours() + 9);
                    i.textColor = i.color;
                    i.color = 'rgba(225,225,225,0.5)';
                    i._id = i.id;
                    if (i.city) {
                        if (!cityList.find(a => a.id === i.city.trim().toUpperCase()))
                            cityList.push({ id: i.city.trim().toUpperCase(), name: this.capitalize(i.city), lat: i.lat, lng: i.lng });
                    }
                });

                cityList.sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                });
                this.setState({ list: j.list, originalList: j.list, cityList: cityList });
                Auth.getLogin(u => {
                    this.setState({ user: u });
                    if (Auth.hasRole('practitioner')) {
                        j.list.forEach(i => {
                            if (i.assignedToUserID === u.id)
                                i.borderColor = u.color;
                        });
                        this.setState({ list: j.list, originalList: j.list });
                    }
                });
                this.loadLegend(j.list);
            }
            else if (j.errorCode !== 0) {
                //this.alert(j.errorMessage);
                this.setState({ noAccess: true });
            }
        }, e => {
            this.alert(e.message);
        });
    }

    renderEventContent(eventInfo) {
        let providerName = eventInfo.event.extendedProps?.providerName;
        let title = eventInfo.event.title;
        if (this.isMobile()) {
            if (title.length > 4)
                title = title.substr(0, 4);
        }
        else {
            if (title.length > 25)
                title = title.substr(0, 25);
        }
        return <div role="button" style={{ color: eventInfo.textColor, textDecoration: eventInfo.event.extendedProps.canceled ? 'line-through' : null }} className={
            [
                eventInfo.event.extendedProps.assignedToUserID === this.state.user.id ? 'my-event' : null,
                eventInfo.event.extendedProps.canceled ? 'text-muted' : null
            ].join(' ')}>
            <i>{title}</i>
        </div>;
    }

    onDatesSet(dateInfo) {
        this.load(dateInfo.start, dateInfo.end);
        if (dateInfo.view.type === 'dayGridMonth') {
            qreq.post('/api/visit/calendar/date/set', { startDate: Globals.toISODateString(dateInfo.start) }, j => { });
        }
        qreq.post('/api/visit/calendar/view/set', { view: dateInfo.view.type }, j => { });
    }



    calculateDistance(x1, y1, x2, y2) {
        return Math.sqrt(Math.exp(x2 - x1) + Math.exp(y2 - y1)) * 55.051;
    }

    onFilterChange(v, name) {
        var city = this.state.filter.city;
        var distance = this.state.filter.distance;
        if (name === 'city')
            city = v;
        else if (name === 'distance')
            distance = v;
        if (city) {
            var find = this.state.cityList.find(a => a.id === city);
            var list = [];
            this.state.originalList.forEach(i => {
                if (i.city === city)
                    list.push(i);
                else if (find && distance) {
                    var delta = this.calculateDistance(i.lat, i.lng, find.lat, find.lng);
                    if (delta <= distance)
                        list.push(i);
                }
            });
            this.setState({ list: list });
        }
        else {
            this.setState({ list: [...this.state.originalList], filter: { ...this.state.filter, distance: 0 } });
        }
    }

    search(value) {
        if (!value || value.length < 1) {
            this.setState({ list: [...this.state.originalList], localFilter: { search: '' } });
            return;
        }
        var list = [];
        this.state.originalList.forEach(i => {
            if (i.patient.fullName.toLowerCase().indexOf(value.toLowerCase()) >= 0)
                list.push(i);
        });
        this.setState({ list: list, localFilter: { search: value } });
    }


    dateClick = (e) => {
        let selectedList = [...this.state.list];

        selectedList = selectedList.filter(x => Globals.toYMDPushDateString(x.plan_date) === Globals.toYMDDateString(e.date));

        if (selectedList.length === 0)
            return;

        this.setState({ showDateModal: true, selectedList });
    }

    // similar to
    eventClick(info) {
        let selectedList = [...this.state.list];

        selectedList = selectedList.filter(x => x.plan_date === info.event.extendedProps.plan_date);

        this.setState({ showDateModal: true, selectedList });
    }


    render() {
        const header = <h1>Calendar</h1>;

        return (
            <div className="c-dashboard">
                {this.state.user?.canWrite && <>
                    <AppFloatingActions>
                        <Link to="/console/visit/new" className="btn btn-primary btn-lg"><Icon icon="faCalendar" /></Link>
                        <Link to="/console/visit/start" className="btn btn-primary btn-lg"><Icon icon="faTruckFast" /></Link>
                    </AppFloatingActions>
                    <div className="d-none d-md-flex mb-3 gap-1">
                        <Link to="/console/visit/new" className="btn btn-primary"><Icon icon="faCalendar" /> <L>Schedule Visit</L></Link>
                        <Link to="/console/visit/start" className="btn btn-primary"><Icon icon="faTruckFast" /> <L>Start Visit</L></Link>
                    </div>
                </>}

                <Modal show={this.state.showDateModal} onHide={() => this.setState({ showDateModal: false })}>
                    <Modal.Header>
                        <Modal.Title><L>Visits</L></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ul className="list-group">
                            {this.state.selectedList?.map((i, idx) => <li key={idx} className="list-group-item">
                                <Link to={'/console/visit/' + i.id + '/order'}>{i.customerName}</Link>
                            </li>)}
                        </ul>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-primary btn-lg" onClick={() => this.setState({ showDateModal: false })}>
                            <L>Close</L>
                        </button>
                    </Modal.Footer>
                </Modal>

                <div className="container-fluid">
                    {header}
                    {this.state.initialView ? <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        initialView={this.state.initialView}
                        initialDate={this.state.initialDate}
                        events={this.state.list}
                        eventContent={this.renderEventContent}
                        datesSet={this.onDatesSet}
                        eventClick={this.eventClick}
                        dateClick={this.dateClick}
                        headerToolbar={{
                            left: "prev,next",
                            center: "title",
                            right: "dayGridMonth,timeGridWeek,timeGridDay"
                        }} height={this.state.calendarHeight} /> : ''}
                    <div className="py-3">
                        <h2>Legend</h2>
                        {this.state.users?.map(i => <span className="me-2" style={{ color: i.color }}><Icon icon="faSquare" /> {i.name}</span>)}
                        <span className="me-2" style={{ color: '#000000' }}><Icon icon="faSquare" /> Unassigned</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default withParamsAndNavigate(Calendar);